export default "__VITE_ASSET__lht1HO4m__"